export const isAuth = () => {
  const tokenObj = JSON.parse(
    window.localStorage.getItem("loginToken") || "{}"
  );
  const access_token =
    (tokenObj.token ? tokenObj.token.access : tokenObj.access_token) || "";
  return !!access_token;
};

export const getAccessToken = () => {
  const tokenObj = JSON.parse(
    window.localStorage.getItem("loginToken") || "{}"
  );
  return (tokenObj.token ? tokenObj.token.access : tokenObj.access_token) || "";
};

export const clearAuth = () => {
  window.localStorage.removeItem("loginToken");
};

/**
 * Trigger auto-login using device credentials
 * Calls the dedicated auto-login endpoint which returns credentials
 */
export const triggerAutoLogin = async (baseUrl, apiKey, tenantId, deviceType, deviceId, subscriberId) => {
  try {
    const url = `${baseUrl}/clients/auth/${tenantId}/auto-login/`;
    
    const body = {
      deviceId: deviceId,
      deviceType: deviceType
    };
    
    // Add subscriberId if provided for verification
    if (subscriberId) {
      body.subscriberId = subscriberId;
    }
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Tenant-Key ${apiKey}`
      },
      body: JSON.stringify(body)
    });
    
    if (response.ok) {
      const data = await response.json();
      
      // The auto-login endpoint returns credentials directly with token structure
      if (data && data.token) {
        window.localStorage.setItem("loginToken", JSON.stringify(data));
        return data;
      } else {
        console.warn('[Auth] No token in auto-login response');
      }
    } else {
      const errorText = await response.text();
      console.error('[Auth] Auto-login failed:', response.status, errorText);
    }
    return null;
  } catch (error) {
    console.error('[Auth] Error during auto-login:', error);
    return null;
  }
};

/**
 * Check URL parameters for session management directives from mobile app
 * 
 * Handles scenarios:
 * 1. logout=true only: Clear session (user logged out)
 * 2. logout=true + deviceType + deviceId + subscriberId: Clear old session, auto-login specific user
 */
export const handleMobileAuthParams = async (baseUrl, apiKey, tenantId) => {
  if (typeof window === "undefined") return;
  
  const urlParams = new URLSearchParams(window.location.search);
  const logout = urlParams.get("logout");
  const deviceType = urlParams.get("deviceType");
  const deviceId = urlParams.get("deviceId");
  const subscriberId = urlParams.get("subscriberId");
  
  // Clear session if requested by mobile app
  if (logout === "true") {
    clearAuth();
    
    // If device info AND subscriber ID provided, trigger auto-login
    if (deviceType && deviceId && subscriberId) {
      try {
        await triggerAutoLogin(baseUrl, apiKey, tenantId, deviceType, deviceId, subscriberId);
      } catch (error) {
        console.error('[Auth] Failed to auto-login:', error);
      }
    }
    
    // Clean the URL
    const newUrl = new URL(window.location);
    newUrl.searchParams.delete("logout");
    newUrl.searchParams.delete("deviceType");
    newUrl.searchParams.delete("deviceId");
    newUrl.searchParams.delete("subscriberId");
    window.history.replaceState({}, document.title, newUrl.toString());
  }
};